/**
 * The function `getChartColorsArray` takes in a string of colors, parses it into an array, and returns
 * an array of valid colors for charting purposes.
 * @param colors - The `colors` parameter is expected to be a JSON string representing an array of
 * color values. Each color value can be either a CSS color name, a CSS variable name, or a combination
 * of a CSS variable name and an alpha value separated by a comma.
 * @returns The function `getChartColorsArray` returns an array of colors.
 */
const getChartColorsArray = (colors) => {
    colors = JSON.parse(colors);
    return colors.map(function (value) {
        var newValue = value.replace(" ", "");
        if (newValue.indexOf(",") === -1) {
            var color = getComputedStyle(document.documentElement).getPropertyValue(newValue);

            if (color.indexOf("#") !== -1)
                color = color.replace(" ", "");
            if (color) return color;
            else return newValue;
        } else {
            var val = value.split(',');
            if (val.length === 2) {
                var rgbaColor = getComputedStyle(document.documentElement).getPropertyValue(val[0]);
                rgbaColor = "rgba(" + rgbaColor + "," + val[1] + ")";
                return rgbaColor;
            } else {
                return newValue;
            }
        }
    });
};

export default getChartColorsArray;